<div class="content-wrapped">
    <!-- Content -->
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 mb-1 text-primary">
            <mat-icon class="me-2 align-middle">fact_check</mat-icon>Reglas de Medios
        </h4>
          <p class="card-text"><small class="text-muted">Actualizado: {{ dataRules.updated }}</small></p>
        <div class="row">
            <div class="col-md-12">
               <div class="iframe-wrap">
                <div class="card h-100 p-0" style="width: 95%;">  
                    <iframe 
                      [src]="dataRules.url | safe"  
                      allow="autoplay"
                      style="height: 700px !important;"
                    >
                  </iframe>
                </div>
               </div>

            </div>
        </div>
    </div>
</div>